export default "__VITE_ASSET__edac5f3a__"